import { memo } from 'react';
import { Box, Loader, ScrollView } from '@betty/moonlight';
import { PAYMENT_STATUS_COMPONENTS } from './PaymentStatus.content';
import { PaymentStatusProps } from './PaymentStatus.types';
import usePaymentStatus from '../../hooks/usePaymentStatus';

function PaymentStatus(props: PaymentStatusProps) {
  const { data } = usePaymentStatus(props);
  const Component = data && PAYMENT_STATUS_COMPONENTS[data.status];

  if (!data) {
    return (
      <Box flex={1} centerContent>
        <Loader />
      </Box>
    );
  }

  return (
    <ScrollView
      contentContainerStyle={{
        paddingTop: 'space-800',
        paddingHorizontal: 'space-400',
        paddingBottom: 'safe-area-inset-bottom',
        minHeight: '100%',
      }}
    >
      {Component && <Component {...data} />}
    </ScrollView>
  );
}

export default memo(PaymentStatus);
